// Textes de la page d'accueil. Les deux langues ont exactement les mêmes clés.
const textes = {
  fr: {
    deconnexion: 'Déconnexion',
    connexionAdmin: 'Connexion admin',
    accrocheCuisine: 'Cuisine libanaise · arménienne · géorgienne',
    accrocheEvenements: 'Événements & privatisations',
    ctaReserver: 'Réserver vos événements',
    ctaFormules: 'Nos formules pour vos événements',
    ctaCarte: 'Découvrir la carte du midi',

    services: 'Nos services',
    evenementsCommandes: 'Événements & commandes',
    reserverTitre: 'Réserver un événement',
    reserverTexte: 'Buffets de mezzés, soirées privées, privatisations…',
    reserverAction: 'Commencer →',
    commanderTitre: 'Passer une commande',
    commanderTexte: 'Plats & mezzés à emporter ou en livraison',
    commanderAction: 'Commander →',
    traiteurTitre: 'Traiteur & événements',
    traiteurTexte: 'Nous nous déplaçons partout en Île-de-France pour vos événements',
    traiteurAction: 'En savoir plus →',

    infos: 'Informations pratiques',
    adresse: 'Adresse',
    itineraire: "Voir l'itinéraire",
    horaires: 'Horaires',
    horairesTexte: 'Ven–Dim soirées · Brunch dimanche 11h30–15h',
    plusInfos: "Plus d'infos",
    contact: 'Contact',
    demanderDevis: 'Demander un devis',
    titreCarte: 'Carte — Le Chalet des Flandres',

    administration: 'Administration',
    adminDevisTitre: 'Gérer les devis',
    adminDevisTexte: 'Suivi, statuts, envoi PDF, calendrier',
    adminAnalyticsTitre: 'Analytics',
    adminAnalyticsTexte: "Chiffre d'affaires et devis, par mois et par an",
    adminMaquetteTitre: 'Maquette 3D',
    adminMaquetteTexte: 'Plans de salle des soirées, réservations, visite à pied',
    adminPhotosTitre: 'Gérer les photos',
    adminPhotosTexte: "Ambiance & affiches d'événements",
    adminCarteTitre: 'Carte & menus',
    adminCarteTexte: 'Produits, mezzés, plats, boissons',
    adminCodeTitre: '🔐 Code du jour',
    adminCodeTexte: "Générer et copier le code d'accès client",
    ouvrir: 'Ouvrir →',
    acceder: 'Accéder →',
    voirCode: 'Voir le code →',

    galeries: 'Galeries',
    galeriesSousTitre: 'Ambiance du lieu & prochains événements',
    ambiance: 'Ambiance & Photos',
    evenementsAVenir: 'Événements à venir',
    voirTout: 'Voir tout',
    ouvrirPhoto: 'Ouvrir la photo',
    ouvrirAffiche: "Ouvrir l'affiche",

    partenaires: 'Nos partenaires',
    partenairesSousTitre: 'Pour aller plus loin que la table',

    avis: 'Ils nous ont fait confiance',
    avisSousTitre: 'Les avis de nos clients sur Google',
    note: (n) => `Note ${n} sur 5`,
    nbAvis: (n) => `${n} avis Google`,
    voirAvis: 'Voir tous les avis →',

    fermer: 'Fermer',
    precedent: 'Précédent',
    suivant: 'Suivant',
    reseaux: 'Réseaux sociaux',
    suivezNous: 'Suivez-nous',
  },

  en: {
    deconnexion: 'Log out',
    connexionAdmin: 'Admin login',
    accrocheCuisine: 'Lebanese · Armenian · Georgian cuisine',
    accrocheEvenements: 'Events & private hire',
    ctaReserver: 'Book your event',
    ctaFormules: 'Our event packages',
    ctaCarte: 'See the lunch menu',

    services: 'Our services',
    evenementsCommandes: 'Events & orders',
    reserverTitre: 'Book an event',
    reserverTexte: 'Mezze buffets, private parties, venue hire…',
    reserverAction: 'Get started →',
    commanderTitre: 'Place an order',
    commanderTexte: 'Dishes & mezze to take away or delivered',
    commanderAction: 'Order →',
    traiteurTitre: 'Catering & events',
    traiteurTexte: 'We cater for your events anywhere in the Paris region',
    traiteurAction: 'Learn more →',

    infos: 'Practical information',
    adresse: 'Address',
    itineraire: 'Get directions',
    horaires: 'Opening hours',
    horairesTexte: 'Fri–Sun evenings · Sunday brunch 11:30am–3pm',
    plusInfos: 'More info',
    contact: 'Contact',
    demanderDevis: 'Request a quote',
    titreCarte: 'Map — Le Chalet des Flandres',

    administration: 'Administration',
    adminDevisTitre: 'Manage quotes',
    adminDevisTexte: 'Tracking, statuses, PDF sending, calendar',
    adminAnalyticsTitre: 'Analytics',
    adminAnalyticsTexte: 'Revenue and quotes, by month and by year',
    adminMaquetteTitre: '3D model',
    adminMaquetteTexte: 'Evening floor plans, bookings, walk-through',
    adminPhotosTitre: 'Manage photos',
    adminPhotosTexte: 'Venue photos & event posters',
    adminCarteTitre: 'Menu & dishes',
    adminCarteTexte: 'Products, mezze, mains, drinks',
    adminCodeTitre: '🔐 Code of the day',
    adminCodeTexte: 'Get and copy the customer access code',
    ouvrir: 'Open →',
    acceder: 'Go →',
    voirCode: 'See the code →',

    galeries: 'Galleries',
    galeriesSousTitre: 'The venue & upcoming events',
    ambiance: 'Venue & photos',
    evenementsAVenir: 'Upcoming events',
    voirTout: 'See all',
    ouvrirPhoto: 'Open photo',
    ouvrirAffiche: 'Open poster',

    partenaires: 'Our partners',
    partenairesSousTitre: 'Going beyond the table',

    avis: 'They trusted us',
    avisSousTitre: 'What our customers say on Google',
    note: (n) => `Rated ${n} out of 5`,
    nbAvis: (n) => `${n} Google reviews`,
    voirAvis: 'See all reviews →',

    fermer: 'Close',
    precedent: 'Previous',
    suivant: 'Next',
    reseaux: 'Social media',
    suivezNous: 'Follow us',
  },
};

export default textes;
